import * as types from '../../actions'; 

const initialState = {
    dynFieldAllItems: [],
    dynFieldItem: [],
    status:0,
    activity:'',
    dynFieldsStatus: 0,
    dynFieldsActivity: '',
    errorData:'', 
    dynFieldsErrorData:'',
    dynFieldMasterItems: [],
    dynFieldMasterStatus:0,
    dynFieldMasterActivity:'',
};

export default function(state = initialState, action) {
    const response = action.response; 
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {
        
        case types.DYNAMIC_FIELDS_MASTER_LIST_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    dynFieldMasterItems: response.data,
                    dynFieldMasterStatus: response.status,
                    dynFieldMasterActivity: types.DYNAMIC_FIELDS_MASTER_LIST_SUCCESS+timeVar,
                };
            }
            else {
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.DYNAMIC_FIELDS_LIST_ERROR+timeVar, 
                    dynFieldsStatus: response.status,
                    dynFieldsActivity: types.DYNAMIC_FIELDS_LIST_ERROR+timeVar,
                    errorData: response.data,
                    dynFieldsErrorData: response.data,
                    response 
                };   
            }    
        case types.DYNAMIC_FIELDS_LIST_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    dynFieldAllItems: response.data,
                    status: response.status,
                    activity: types.DYNAMIC_FIELDS_LIST_SUCCESS+timeVar,
                    dynFieldsStatus: response.status,
                    dynFieldsActivity: types.DYNAMIC_FIELDS_LIST_SUCCESS+timeVar
                };
            }
            else {
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.DYNAMIC_FIELDS_LIST_ERROR+timeVar, 
                    dynFieldsStatus: response.status,
                    dynFieldsActivity: types.DYNAMIC_FIELDS_LIST_ERROR+timeVar,
                    errorData: response.data,
                    dynFieldsErrorData: response.data,
                    response 
                };   
            }    
        case types.DYNAMIC_FIELDS_LIST_ERROR:
            return {
                ...state, 
                dynFieldAllItems: response.data,
                status: (response && response.status) ? response.status : '',
                activity: types.DYNAMIC_FIELDS_LIST_ERROR+timeVar, 
                dynFieldsStatus: (response && response.status) ? response.status : '',
                dynFieldsActivity: types.DYNAMIC_FIELDS_LIST_ERROR+timeVar,
                errorData: response.data,
                dynFieldsErrorData: response.data,
                response 
            };  
 

        case types.DYNAMIC_FIELDS_UPDATE_SUCCESS:
            if(response.status===200){ 

                return {
                    ...state,
                    status: response.status,
                    activity: types.DYNAMIC_FIELDS_UPDATE_SUCCESS+timeVar,
                    dynFieldsStatus: response.status,
                    dynFieldsActivity: types.DYNAMIC_FIELDS_UPDATE_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.DYNAMIC_FIELDS_UPDATE_ERROR+timeVar, 
                    dynFieldsStatus: (response && response.status) ? response.status : '',
                    dynFieldsActivity: types.DYNAMIC_FIELDS_UPDATE_ERROR+timeVar,
                    errorData: response.data,
                    dynFieldsErrorData: response.data,
                    response 
                };   
            }
        case types.DYNAMIC_FIELDS_UPDATE_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.DYNAMIC_FIELDS_UPDATE_ERROR+timeVar, 
                dynFieldsStatus: (response && response.status) ? response.status : '',
                dynFieldsActivity: types.DYNAMIC_FIELDS_UPDATE_ERROR+timeVar,
                errorData: response.data,
                dynFieldsErrorData: response.data,
                response 
            };    
        
            
        case types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    status: response.status,
                    activity: types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS+timeVar,
                    dynFieldsSavedData: response.data,
                    dynFieldsStatus: response.status,
                    dynFieldsActivity: types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.DYNAMIC_FIELDS_DATA_SAVE_ERROR+timeVar, 
                    dynFieldsStatus: (response && response.status) ? response.status : '',
                    dynFieldsActivity: types.DYNAMIC_FIELDS_DATA_SAVE_ERROR+timeVar,
                    errorData: response.data,
                    dynFieldsErrorData: response.data,
                    response 
                };   
            }
        case types.DYNAMIC_FIELDS_DATA_SAVE_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.DYNAMIC_FIELDS_DATA_SAVE_ERROR+timeVar, 
                dynFieldsStatus: (response && response.status) ? response.status : '',
                dynFieldsActivity: types.DYNAMIC_FIELDS_DATA_SAVE_ERROR+timeVar,
                errorData: response.data,
                dynFieldsErrorData: response.data,
                response 
            };     
            
        case types.CLEAR:
            return {
                ...state, 
                activity:'',
                status:0,
                dynFieldsStatus: 0,
                dynFieldsActivity: '',     
                errorData: '',
                dynFieldsErrorData: '',          
            }  

        default:
            return state;
    }
};
